/**
 * @flow
 * @format
 */

import React from 'react';
import { connect } from 'react-redux';
import { compose, withHandlers, type HOC } from 'recompose';
import _ from 'lodash';
import cc from 'classcat';
import VisibilitySensor from 'react-visibility-sensor';
import FaQuestionCircle from 'react-icons/lib/fa/question-circle';

import { actions } from '~/actions/design';
import Aux from '~/utils/react-aux';
import { createHTMLMarkup } from '~/utils';

import FieldWrapper from '../FieldWrapper';
import FieldMessage from '../FieldMessage';
import HoverTooltip from '../HoverTooltip';

import classes from './SubStepWrapper.scss';

type OwnPropsType = {
  data: StepSectionData,
};

type EnhancedProps = {
  onChange: Function,
  onRevert: Function,
};

type PropsType = EnhancedProps & OwnPropsType;

export class SubStepWrapper extends React.PureComponent<PropsType, *> {
  static defaultProps = {
    data: {
      badge: '',
      fields: {},
      images: [],
    },
  };
  props: PropsType;

  render() {
    const { data, onChange, onRevert } = this.props;
    const badge = data.badge ? `${data.badge.toString()}: ` : '';

    const renderFields = () =>
      _.map(data.fields, (fieldData: StepFieldData, key: string) => {
        const getField = () => {
          switch (fieldData.type) {
            case 'message': {
              return (
                <FieldMessage
                  data={fieldData}
                  style={
                    key === 'DtyCy_message'
                      ? { backgroundColor: 'mistyrose' }
                      : {}
                  }
                  id={key}
                />
              );
            }
            default: {
              return (
                <FieldWrapper
                  onChangeHandler={onChange}
                  onRevertHandler={onRevert}
                  id={key}
                  data={fieldData}
                />
              );
            }
          }
        };

        return (
          <VisibilitySensor
            offset={{ top: 10, bottom: 10 }}
            scrollCheck
            delayedCall
            key={key}
          >
            {getField()}
          </VisibilitySensor>
        );
      });

    const blockTitle = `${badge}${data.name}`;
    const tooltipDiv = data.description ? (
      <HoverTooltip
        id={_.kebabCase(blockTitle)}
        title={createHTMLMarkup(blockTitle)}
        text={createHTMLMarkup(data.description)}
      >
        <FaQuestionCircle className={classes.infoIcon} size={24} />
      </HoverTooltip>
    ) : null;

    return (
      <Aux>
        <h4 className={cc([classes.cardHeader])} id={_.kebabCase(blockTitle)}>
          {blockTitle}
          {tooltipDiv}
        </h4>
        {renderFields()}
      </Aux>
    );
  }
}

function mapStateToProps(
  state: AppStateType,
  ownProps: OwnPropsType,
): OwnPropsType {
  return {
    ...ownProps,
  };
}

type HType = OwnPropsType & AppDispatch;
const enhancer: HOC<*, OwnPropsType> = compose(
  connect(mapStateToProps),
  withHandlers({
    onChange: (props: HType) => (id: string) => (e: InputEvent) => {
      // This should prob be moved somewhere else (config maybe?)
      const fieldData = _.get(props, ['data', 'fields', id], {});
      const dataTarget: string = _.get(fieldData, 'dataTarget', id);
      const isSelection = ['dropdown', 'radio', 'selecttable'].includes(
        fieldData.type,
      );
      const value = _.get(e.target, 'value');

      // return props.dispatch(actions.changeValue({
      //   field: fieldId, value, isSelection,
      // }));
      return props.dispatch(
        actions.changeValue({
          field: dataTarget,
          value,
          isSelection,
          fieldId: id,
        }),
      );
    },
    onRevert: (props: HType) => (id: string) => {
      const fieldData = _.get(props, ['data', 'fields', id], {});
      const fieldId = _.get(fieldData, ['dataTarget'], id);
      const isSelect = ['dropdown', 'radio', 'selecttable'].includes(
        fieldData.type,
      );

      // Extra field needed to handle part reset cases (see ref#122)
      const revertFieldId: string = _.get(fieldData, ['revertTarget']);

      return props.dispatch(
        actions.revertField({
          id: revertFieldId || fieldId,
          isSelect,
        }),
      );
    },
  }),
);

export default enhancer(SubStepWrapper);



// WEBPACK FOOTER //
// ./src/components/SubStepWrapper/SubStepWrapper.js